import React, { useContext } from "react";
import { CartContext } from "./CartContext"; // ✅ Import CartContext

function ProductCard({ image, name, price }) {
  const { addToCart } = useContext(CartContext); // ✅ Get addToCart function

  const handleAddToCart = () => {
    const item = { image, name, price, id: Date.now() }; // ✅ Create an item object with a unique ID
    addToCart(item); // ✅ Add item to cart
  };

  return (
    <div className="Card-C">
      <img src={image} alt={name} />
      <h2 className="card-title">{name}</h2>
      <p className="card-Price">₹{price}</p>
      <button className="buy-btn" onClick={handleAddToCart}> {/* ✅ Call addToCart */}
        Buy
      </button>
    </div>
  );
}

export default ProductCard;
